import * as React from 'react';
import {SvgIconProps} from '@material-ui/core/SvgIcon'

interface MenuItem {
  messageId: string,
  defaultMessage: string,
  icon?: React.ComponentType<SvgIconProps>,
  activeIcon?: React.ComponentType<SvgIconProps>,
  onClick: (item: MenuItem) => void
  disableHighlight?: boolean,
  submenus?: MenuItem[]
  link?: string
  externalLink?: ExternalLink
}

interface ExternalLink {
  link: string
  newWindow?: boolean
}

class ItemBuilder {
  private thisItem: MenuItem = <any>{};
  private callback: () => MenuBuilder;

  constructor(callback: () => MenuBuilder, messageId: string, defaultMesage: string){
    this.callback = callback;
    this.thisItem.messageId = messageId;
    this.thisItem.defaultMessage = defaultMesage;
  }

  get(): MenuItem {
    return this.thisItem;
  }

  item(messageId: string, defaultMesage: string): ItemBuilder {
    return this.callback().item(messageId, defaultMesage)
  }

  build(): MenuItem[] {
    return this.callback().build();
  }

  icon(icon: React.ComponentType<SvgIconProps>): ItemBuilder {
    this.thisItem.icon = icon;
    return this;
  }

  activeIcon(icon: React.ComponentType<SvgIconProps>): ItemBuilder {
    this.thisItem.activeIcon = icon;
    return this;
  }

  onClick(callback: (item: MenuItem) => void): ItemBuilder {
    this.thisItem.onClick = callback;
    return this;
  }

  submenus(items: MenuItem[]): ItemBuilder {
    this.thisItem.submenus = items;
    return this;
  }

  disableHighlight(): ItemBuilder {
    this.thisItem.disableHighlight = true;
    return this;
  }

  link(link: string): ItemBuilder {
    this.thisItem.link = link;
    return this;
  }

  externalLink(link: string, newWindow: boolean = false): ItemBuilder {
    this.thisItem.externalLink = {link, newWindow};
    return this;
  }
}

export class MenuBuilder {

  private readonly items: MenuItem[];
  private currentBuilder: ItemBuilder;
  private onClick: (item: MenuItem) => void;

  constructor() {
    this.items = [];
  }

  private finishItem(): MenuBuilder {
    this.items.push(this.currentBuilder.get());
    return this;
  }

  globalOnClick(onClick: (item: MenuItem) => void): MenuBuilder {
    this.onClick = onClick;
    return this;
  }

  item( messageId: string, defaultMessage: string ): ItemBuilder{
    this.currentBuilder = new ItemBuilder(this.finishItem.bind(this), messageId, defaultMessage);
    return this.currentBuilder;
  }

  build(): MenuItem[] {
    return this.addGlobalListener(this.items);
  }

  private addGlobalListener(items: MenuItem[]) {
    if(this.onClick !== undefined )
    {
      items.forEach( item => {
        if( item.onClick === undefined && item.submenus === undefined)
        {
          item.onClick = this.onClick;
        }
        if(item.submenus !== undefined)
        {
          this.addGlobalListener(item.submenus)
        }
      });
    }
    return items;
  }
}


// WEBPACK FOOTER //
// ../../src/Layout/MenuBuilder.ts